const getters = {
  schema(state) {
    return state.schema
  },
}

export default getters
